import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/st-francis-mn")({
  beforeLoad: () => {
    throw redirect({
      to: "/service-areas/$slug",
      params: { slug: "saint-francis" },
      statusCode: 301,
    });
  },
});
